import React, { Component } from 'react'
import Logo from '../images/2020-branding/logo.png'
import '../css/main/maintenance.sass'

class MaintenancePage extends Component {
  render() {
    return (
      <div className="maintenance-page">
        <img src={Logo} />
        <h2>Avatar Nutrition is down for maintenance.</h2>
      </div>
    )
  }
}

export default MaintenancePage;